/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  PropType,
  computed,
} from "vue";

export default defineComponent({
  name: "c-modal",

  props: {
    message: { type: String, default: "" },
    isLoading: { type: Boolean as PropType<boolean>, default: false },
    confirm: { type: [Boolean, String], default: "componentModalConfirm" },
    cancel: { type: String, default: "componentModalCancel" },
    modalSize: { type: String, default: "modal-xs" },
    text: {
      type: String,
      default: "componentModalConfirmMessage", //"Are you certain you want to carry out this action?",
    },
    isText: { type: Boolean, default: false },
    labelText: { type: String, default: "componentModalConfirmation" },
    refId: { type: String, default: "confirmation" },
    payloads: {
      type: [Array, Object] as PropType<any[] | Record<string, any>>,
      default: () => [],
    },
    actions: {
      type: [Array, Object] as PropType<any[] | Record<string, any>>,
      default: () => [],
    },
    headerClass: { type: String, default: "pt10 pb10 pl16 pr16" },
    contentClass: { type: String, default: "p12" },
    footerClass: { type: String, default: "p12 pr17" },
    isAction: { type: Boolean, default: true },
    active: { type: Boolean, default: false },
    isOverlay: { type: Boolean, default: false },
    custom: { type: Boolean, default: false },
  },

  emits: ["onClose", "onConfirm"],

  setup(props, { emit }) {
    const isActive = computed(() => {
      return props.active;
    });

    const onClose = () => {
      emit("onClose");
    };

    const onConfirm = () => {
      emit("onConfirm");
    };

    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "Escape" && !props.isOverlay) {
        onClose();
      }
    };

    onMounted(() => {
      document.addEventListener("keydown", handleKeyPress);
    });

    onBeforeUnmount(() => {
      document.removeEventListener("keydown", handleKeyPress);
    });

    const overLayClick = () => {
      if (!props.isOverlay) {
        onClose();
      }
    };

    return {
      isActive,
      onClose,
      onConfirm,
      overLayClick,
    };
  },
});
